import {Routes} from '@angular/router';
import {TenantsListComponent} from './tenants/features/tenants-list/tenants-list.component';
import {UsersListComponent} from './users/features/users-list/users-list.component';
import {LoginComponent} from './auth/features/login/login.component';
import {AuthGuard} from './auth/guards/auth.guard';
import {ConversationsListComponent} from './conversations/features/conversations-list/conversations-list.component';
import {AssignmentListComponent} from './assignment/features/assignment-list/assignment-list.component';
import {ProfileComponent} from './users/features/profile/profile.component';
import {DashboardComponent} from './dashboard/dashboard/dashboard.component';
import {TemplatesListComponent} from './templates/features/templates-list/templates-list.component';
import {TeamListComponent} from './teams/features/team-list/team-list.component';
import {SettingsComponent} from './users/features/settings/settings.component';
import {ContactsPageComponent} from './contacts/features/contacts-page/contacts-page.component';

export const routes: Routes = [
  {path: 'login', component: LoginComponent,},
  {path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard]},
  {path: 'chat', component: ConversationsListComponent, canActivate: [AuthGuard]},
  {path: 'tenants', component: TenantsListComponent, canActivate: [AuthGuard]},
  {path: 'assignments', component: AssignmentListComponent, canActivate: [AuthGuard]},
  {path: 'conversations', component: ConversationsListComponent, canActivate: [AuthGuard]},
  {path: 'users', component: UsersListComponent, canActivate: [AuthGuard]},
  {path: 'templates', component: TemplatesListComponent, canActivate: [AuthGuard]},
  {path: 'teams', component: TeamListComponent, canActivate: [AuthGuard]},
  {path: 'contacts', component: ContactsPageComponent, canActivate: [AuthGuard]},
  {path: 'profile', component: ProfileComponent, canActivate: [AuthGuard]},
  {path: 'settings', component: SettingsComponent, canActivate: [AuthGuard]},
  {path: '', redirectTo: 'login', pathMatch: 'full'},
];
